export const getMaxValueFromBarStatsData = (data) => {
    if (!data || data.length === 0) {
        return 0;
    }
    return Math.max(...data.flatMap((item) => {
        if (Array.isArray(item.value)) {
            return item.value;
        }
        return [item.value];
    }));
};
